export default __webpack_public_path__ + "static/media/ghn-icon.41a6a482.png";